/**
 * Entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class Country extends BaseModel {
    defaults() {
        return {
            id: null,
            iso: null,
            printable_name: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
        };
    }

    entityName() {
        return 'Country';
    }
}

export class CountryCollection extends BaseCollection {
    options() {
        return {
            model: Country,
        };
    }

    entityName() {
        return 'Country';
    }
}
